"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var ProgressBar = function ProgressBar(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-c-progress-wrap"
  }, props.bars.map(function (bar) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: JSON.stringify(bar),
      className: "d8-c-progress-bar ".concat(bar.background),
      role: "progressbar",
      style: {
        width: bar.value
      },
      "aria-valuenow": bar.value,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    });
  }));
};
ProgressBar.propTypes = {
  bars: _propTypes["default"].array
};
var _default = exports["default"] = ProgressBar;